import { combineReducers } from 'redux';

import listing from "../reducers/listing";
import forms from "../reducers/forms";
import user from "../reducers/user";
import stocks from "../reducers/stocks";
import configuration from "../reducers/configuration";
import leverage from "../reducers/leverage";
import admin from "../reducers/admin";
import strategy from "../reducers/strategy";
import tracking from "../reducers/tracking";
import home from "../reducers/home";
import tags from "../reducers/tags";
import zerodha from "../reducers/zerodha";

const rootReducer = combineReducers({
    listing, forms, user, stocks, configuration,
    leverage, admin, strategy, tracking, home,
    tags, zerodha
});

export default rootReducer;
